// extracted by mini-css-extract-plugin
export default {"card":"NewsCard_card__d6sXM","image":"NewsCard_image__n8ZIU","content":"NewsCard_content__NpwWu","buttons":"NewsCard_buttons__AG10Z"};